export default "__VITE_ASSET__36dae70f__"